import React, { Component } from "react";
import {
  /* Container, Card, CardContent, CardHeader, */ Divider,
  /* Grid, */ InputLabel,
  Select,
  Typography,
  MenuItem,
  Box,
  FormControl,
  Input,
  FormControlLabel,
  Checkbox,
  TextField,
  FormHelperText,
  Stack,
} from "@mui/material";
import { withStyles } from "@material-ui/core/styles";
import ApiService from "../../ApiService";
import { Alert } from "@mui/material";
import Button from "../../components/Custom/Button/Button";
import { Chip, OutlinedInput } from "@material-ui/core";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const useStyles = (theme) => ({
  topCard: {
    marginTop: theme.spacing(1),
    minHeight: "100vh",
  },
  large: {
    width: theme.spacing(10),
    height: theme.spacing(10),
    marginBottom: 10,
  },
});

class AddUserForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: null,
      userName: null,
      password: this.generatePassword(),
      roleId: null,
      role: [],
      roles: [],
      merchants: [],
      userMerchantId: null,
      userMerchantIds: [],
      email: null,
      firstName: null,
      lastName: null,
      phone: null,
      city: null,
      state: null,
      country: null,
      zip: null,
      active: false,
      responseMessage: null,
      failed: false,
      success: false,
      portalPassword: null,
      signkey: null,
      industry: null,
      merchantName: null,
      orgRegistrationNumber: null,
      website: null,
      isIpWhiteList: true,
      isCardWhiteList: true,
      isMasterMerchant: false,
      isSubMerchant: false,
      isAdmin: false,
      isReseller: false,
      merchantCity: null,
      merchantCountry: null,
      merchantZip: null,
      merchantAddress: null,
      merchantPhone: null,
      error: false,
      fax: null,
      resellerCharge: null,
      resellerWeeklyLimit: null,
      state: null,
      errorMsg: null,
      err: false,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleRoleChange = this.handleRoleChange.bind(this);
    this.fetchAllMerchants = this.fetchAllMerchants.bind(this);
    this.fetchUserRoles = this.fetchUserRoles.bind(this);
  }
  generatePassword = (
    length = 20,
    wishlist = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz!@-#$"
  ) =>
    Array(length)
      .fill("")
      .map(
        () =>
          wishlist[
            Math.floor(
              (crypto.getRandomValues(new Uint32Array(1))[0] /
                (0xffffffff + 1)) *
                wishlist.length
            )
          ]
      )
      .join("");

  generateSignkey = (
    length = 12,
    wishlist = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz"
  ) =>
    Array(length)
      .fill("")
      .map(
        () =>
          wishlist[
            Math.floor(
              (crypto.getRandomValues(new Uint32Array(1))[0] /
                (0xffffffff + 1)) *
                wishlist.length
            )
          ]
      )
      .join("");

  handleInputChange(event) {
    const target = event.target;
    const inputName = target.name;
    const inputValue = target.value;
    this.setState({
      [inputName]: inputValue,
    });
  }

  handleChange = (event) => {
    const value = event.target.value;

    // Validate the input using regular expressions
    if (/^\d{0,7}(\.\d{0,2})?$/.test(value) || value === "") {
      this.setState({
        [event.target.name]: value,
      });
    }
  };

  handleCountryChange = (event) => {
    const newValue = event.target.value.slice(0, 3);

    if (newValue.length <= 3) {
      this.setState({
        country: newValue,
        error: false,
      });
    } else {
      this.setState({
        error: true,
      });
    }
  };

  handleRoleChange(event) {
    this.handleInputChange(event);
    this.setState({ roleId: event.target.value.id });
    if (event.target.value.type === "ADMIN") {
      this.setState({
        isMasterMerchant: false,
        isSubMerchant: false,
        isReseller: false,
        isAdmin: true,
      });
    } else if (event.target.value.type === "SUBMERCHANT") {
      this.setState({
        isMasterMerchant: false,
        isReseller: false,
        isSubMerchant: true,
        isAdmin: false,
      });
    } else if (event.target.value.type === "RESELLER") {
      this.setState({
        isMasterMerchant: false,
        isSubMerchant: false,
        isAdmin: false,
        isReseller: true,
      });
    } else if (event.target.value.type === "MERCHANT") {
      this.setState({
        isMasterMerchant: true,
        isSubMerchant: false,
        isReseller: false,
        isAdmin: false,
        signkey: Math.random().toString(16).slice(-8),
      });
    }
  }
  componentDidMount() {
    this.fetchAllMerchants();
    this.fetchUserRoles();
  }
  fetchUserRoles() {
    ApiService.fetchUserRoles().then((res) => {
      this.setState({ roles: res.data });
    });
  }

  fetchAllMerchants() {
    ApiService.fetchAllMerchants().then((res) => {
      this.setState({ merchants: res.data });
    });
  }
  handleCheckboxChange(event) {
    if (event.target.checked) this.setState({ active: true });
    else this.setState({ active: false });
  }
  handleSubmit(e) {
    var request = Object.assign({}, this.state);

    ApiService.addAmendUser(request)
      .then((res) => {
        if (res.data.status === "OK") {
          this.setState({
            failed: false,
            success: true,
            responseMessage: res.data.responseMessage,
          });
          this.props.reloadData();
        } else
          this.setState({
            failed: true,
            success: false,
            responseMessage: res.data.responseMessage,
          });
      })
      .catch((e) => {
        this.setState({ failed: true, responseMessage: "Error" });
      });
  }
  render() {
    /* const { classes } = this.props; */
    return (
      <form>
        {this.state.failed && (
          <Alert severity="error" elevation="0">
            {" "}
            {this.state.responseMessage}
          </Alert>
        )}
        {this.state.success && (
          <Alert severity="success" elevation="0">
            {this.state.responseMessage}
          </Alert>
        )}

        <TextField
          name="userName"
          placeholder="Username"
          fullWidth
          margin="dense"
          error={this.state.userName === null}
          value={this.state.userName}
          onChange={this.handleInputChange}
          required
          helperText={this.state.userName === null && "Value is required"}
        />

        <TextField
          name="password"
          placeholder="Password"
          error={this.state.password === null}
          fullWidth
          margin="dense"
          value={this.state.password}
          onChange={this.handleInputChange}
          required
          helperText={this.state.password === null && "Value is required"}
        />

        <FormControl fullWidth margin="dense">
          <InputLabel id="roleIdLabel">User Role</InputLabel>
          <Select
            value={this.state.role}
            error={this.state.roleId === null}
            onChange={this.handleRoleChange}
            name="role"
            labelId="roleIdLabel"
            id="role"
            aria-describedby="role-helper-text"
          >
            <MenuItem key="" value="">
              &nbsp;{" "}
            </MenuItem>
            {this.state.roles &&
              this.state.roles.map((r) => (
                <MenuItem key={r.id} value={r} dense>
                  {" "}
                  {r.type}{" "}
                </MenuItem>
              ))}
          </Select>
          {this.state.roleId === null && (
            <FormHelperText id="role-helper-text" error>
              Value is required
            </FormHelperText>
          )}
        </FormControl>

        <TextField
          name="email"
          placeholder="Email"
          fullWidth
          error={this.state.email == null}
          margin="dense"
          type="email"
          value={this.state.email}
          onChange={this.handleInputChange}
          required
          helperText={this.state.email == null && "Value is required"}
        />

        <FormControl fullWidth margin="dense">
          <Input
            name="phone"
            placeholder="Phone"
            value={this.state.phone}
            onChange={this.handleInputChange}
          />
        </FormControl>
        <FormControl fullWidth margin="dense">
          <Input
            name="firstName"
            placeholder="First Name"
            value={this.state.firstName}
            onChange={this.handleInputChange}
            required
          />
        </FormControl>
        <FormControl fullWidth margin="dense">
          <Input
            name="lastName"
            placeholder="Last Name"
            value={this.state.lastName}
            onChange={this.handleInputChange}
            required
          />
        </FormControl>
        <FormControl fullWidth margin="dense">
          <Input
            name="address"
            placeholder="Address"
            value={this.state.address}
            onChange={this.handleInputChange}
          />
        </FormControl>
        <FormControl fullWidth margin="dense">
          <Input
            name="city"
            placeholder="City"
            value={this.state.city}
            onChange={this.handleInputChange}
            required
          />
        </FormControl>
        <FormControl fullWidth margin="dense">
          <Input
            name="country"
            placeholder="Country"
            value={this.state.country}
            onChange={this.handleCountryChange}
          />
          {/* {this.state.error && (
            <Typography color="error" variant="subtitle2">
              Country should not exceed three characters
            </Typography>
          )} */}
        </FormControl>
        <FormControl fullWidth margin="dense">
          <Input
            name="zip"
            placeholder="Zip"
            value={this.state.zip}
            onChange={this.handleInputChange}
          />
        </FormControl>
        <FormControl fullWidth margin="dense">
          <FormControlLabel
            control={
              <Checkbox
                checked={this.state.active}
                onChange={this.handleCheckboxChange}
                name="active"
                id="active"
                color="primary"
              />
            }
            label="Is Active"
          />
        </FormControl>
        {this.state.isSubMerchant && (
          <FormControl fullWidth margin="dense">
            <InputLabel id="merchantsLable">Select Merchant</InputLabel>
            <Select
              value={this.state.userMerchantId}
              onChange={this.handleInputChange}
              name="userMerchantId"
              labelId="merchantsLable"
              id="userMerchantId"
            >
              <MenuItem key="" value="">
                &nbsp;{" "}
              </MenuItem>
              {this.state.merchants &&
                this.state.merchants.map((m) => (
                  <MenuItem key={m.id} value={m.id} dense>
                    {" "}
                    {m.merchantName + "-" + m.code}{" "}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        )}
        {this.state.isReseller && (
          <FormControl required fullWidth margin="dense">
            <InputLabel id="merchantsLables">Select Merchant</InputLabel>
            <Select
              labelId="merchantsLables"
              id="userMerchantIds"
              name="userMerchantIds"
              multiple
              value={this.state.userMerchantIds}
              error={this.state.userMerchantIds.length === 0}
              onChange={this.handleInputChange}
              renderName={(selected) => selected.join(", ")}
            >
              {this.state.merchants &&
                this.state.merchants.map((m) => (
                  <MenuItem key={m.id} value={m.id} name={m.merchantName} dense>
                    {" "}
                    {m.merchantName + "-" + m.code}{" "}
                  </MenuItem>
                ))}
            </Select>
            {this.state.userMerchantIds.length === 0 && (
              <FormHelperText id="role-helper-text" error>
                Value is required
              </FormHelperText>
            )}
          </FormControl>
        )}
        {(this.state.isMasterMerchant === true ||
          this.state.isReseller === true) && (
          <>
            <Divider />
            {this.state.isReseller ? (
              <Typography varient="h5" style={{ padding: "1em" }}>
                {" "}
                Reseller details{" "}
              </Typography>
            ) : (
              <Typography varient="h5" style={{ padding: "1em" }}>
                {" "}
                Merchant details{" "}
              </Typography>
            )}
            <Divider />

            <TextField
              name="merchantName"
              placeholder={
                this.state.isReseller ? "Reseller name" : "Merchant name"
              }
              value={this.state.merchantName}
              onChange={this.handleInputChange}
              required
              fullWidth
              margin="dense"
              error={this.state.merchantName === null}
              helperText={
                this.state.merchantName === null && "Value is required"
              }
            />

            {this.state.isMasterMerchant && (
              <TextField
                name="signkey"
                placeholder="API SignKey"
                value={this.state.signkey}
                onChange={this.handleInputChange}
                fullWidth
                margin="dense"
                error={this.state.signkey === null}
                helperText={this.state.signkey === null && "Value is required"}
              />
            )}

            <TextField
              name="website"
              placeholder="Website"
              value={this.state.website}
              onChange={this.handleInputChange}
              fullWidth
              margin="dense"
              error={this.state.website === null}
              helperText={this.state.website === null && "Value is required"}
            />

            {this.state.isReseller && (
              <div>
                <TextField
                  name="resellerCharge"
                  placeholder="resellerCharge"
                  value={this.state.resellerCharge}
                  onChange={this.handleChange}
                  fullWidth
                  margin="dense"
                  error={this.state.resellerCharge === null}
                  helperText={
                    this.state.resellerCharge === null && "Value is required"
                  }
                />

                <TextField
                  name="resellerWeeklyLimit"
                  placeholder="resellerWeeklyLimit"
                  value={this.state.resellerWeeklyLimit}
                  onChange={this.handleChange}
                  fullWidth
                  margin="dense"
                  error={this.state.resellerWeeklyLimit === null}
                  helperText={
                    this.state.resellerWeeklyLimit === null &&
                    "Value is required"
                  }
                />
              </div>
            )}

            <FormControl fullWidth margin="dense">
              <Input
                name="merchantPhone"
                placeholder={
                  this.state.isReseller ? "Reseller Phone" : "Merchant Phone"
                }
                value={this.state.merchantPhone}
                onChange={this.handleInputChange}
              />
            </FormControl>

            {this.state.isReseller && (
              <FormControl fullWidth margin="dense">
                <Input
                  name="fax"
                  placeholder="fax"
                  value={this.state.fax}
                  onChange={this.handleInputChange}
                  required
                />
              </FormControl>
            )}

            <FormControl fullWidth margin="dense">
              <Input
                name="orgRegistrationNumber"
                placeholder="Org Registration Number"
                value={this.state.orgRegistrationNumber}
                onChange={this.handleInputChange}
              />
            </FormControl>
            <FormControl fullWidth margin="dense">
              <Input
                name="merchantAddress"
                placeholder={
                  this.state.isReseller
                    ? "Reseller Address"
                    : "Merchant Address"
                }
                value={this.state.merchantAddress}
                onChange={this.handleInputChange}
              />
            </FormControl>
            <FormControl fullWidth margin="dense">
              <Input
                name="merchantCity"
                placeholder={
                  this.state.isReseller ? "Reseller City" : "Merchant City"
                }
                value={this.state.merchantCity}
                onChange={this.handleInputChange}
                required
              />
            </FormControl>

            {this.state.isReseller && (
              <FormControl fullWidth margin="dense">
                <Input
                  name="state"
                  placeholder="state"
                  value={this.state.state}
                  onChange={this.handleInputChange}
                  required
                />
              </FormControl>
            )}
            <FormControl fullWidth margin="dense">
              <Input
                name="merchantCountry"
                placeholder={
                  this.state.isReseller
                    ? "Reseller Country"
                    : "Merchant Country"
                }
                value={this.state.merchantCountry}
                onChange={this.handleInputChange}
                required
              />
            </FormControl>
            <FormControl fullWidth margin="dense">
              <Input
                name="merchantZip"
                placeholder={
                  this.state.isReseller ? "Reseller Zip" : "Merchant Zip"
                }
                value={this.state.merchantZip}
                onChange={this.handleInputChange}
              />
            </FormControl>
            <FormControl fullWidth margin="dense">
              <Input
                name="industry"
                placeholder="Industry"
                value={this.state.industry}
                onChange={this.handleInputChange}
              />
            </FormControl>

            {this.state.isMasterMerchant && (
              <FormControl fullWidth margin="dense">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.isIpWhiteList}
                      onChange={this.handleCheckboxChange}
                      name="isIpWhiteList"
                      id="isIpWhiteList"
                      color="primary"
                    />
                  }
                  label="IP WhiteList Enabled"
                />
              </FormControl>
            )}
            {this.state.isMasterMerchant && (
              <FormControl fullWidth margin="dense">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.isCardWhiteList}
                      onChange={this.handleCheckboxChange}
                      name="isCardWhiteList"
                      id="isCardWhiteList"
                      color="primary"
                    />
                  }
                  label="Card WhiteList Enabled"
                />
              </FormControl>
            )}
          </>
        )}

        <Box align="center">
          <Button
            onClick={this.handleSubmit}
            variant="contained"
            color="primary"
          >
            Save{" "}
          </Button>
        </Box>
      </form>
    );
  }
}
export default withStyles(useStyles)(AddUserForm);
